import {Outlet} from "react-router-dom";
import SideMenuBar from "../sideBar/SideMenuBar";
import "./AppLayout.scss";
import React from "react";
import {observer} from "mobx-react-lite";
import {AuthenticatedTemplate} from "@azure/msal-react";


const AppLayout = ({ filter = true }) => {
  return (
    <AuthenticatedTemplate>
      <div data-testid={"app-layout"} className="layout">
        <SideMenuBar />
        <Outlet />
      </div>
    </AuthenticatedTemplate>
  );
};

export default observer(AppLayout);
